export default "__VITE_ASSET__M_sF8X1h__"